import { useNavigate } from "react-router-dom";
import { PATH_ROOT } from "@/routes/paths";
import { useIsDemo } from "@/hooks/common/useIsDemo";

import { useCalendarData } from "@/hooks/calendar/useCalendarData";
import { Widget } from "./Widget";
import { TodoTaskItem } from "./TodoTaskItem";
import { IconCalendarClock } from "@/components/icons";
import type { DragHandleProps } from "../../constants";

export const TodoWidget = ({ dragHandleProps }: { dragHandleProps?: DragHandleProps }) => {
  const navigate = useNavigate();
  const isDemo = useIsDemo();
  const { tasks: calendarTasks } = useCalendarData();
  const incompleteTasks = calendarTasks.filter((t) => !t.completed).slice(0, 5);

  return (
    <Widget
      title="Tasks"
      icon={<IconCalendarClock className="size-5" aria-hidden="true" />}
      linkTo={isDemo ? PATH_ROOT.demo.calendar : PATH_ROOT.main.calendar}
      linkText="View tasks"
      dragHandleProps={dragHandleProps}
    >
      <div className="flex flex-col gap-2">
        {incompleteTasks.map((task) => (
          <TodoTaskItem
            key={task.id}
            task={task}
            onClick={() => navigate(isDemo ? PATH_ROOT.demo.calendar : PATH_ROOT.main.calendar)}
          />
        ))}
        {incompleteTasks.length === 0 && (
          <div className="text-muted-foreground text-sm text-center py-4">All tasks completed!</div>
        )}
      </div>
    </Widget>
  );
};
